import { render, staticRenderFns } from "./cursos.vue?vue&type=template&id=36844bd1&scoped=true"
import script from "./cursos.vue?vue&type=script&lang=js"
export * from "./cursos.vue?vue&type=script&lang=js"
import style0 from "./cursos.vue?vue&type=style&index=0&id=36844bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36844bd1",
  null
  
)

export default component.exports